import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Button, Dialog } from 'antd-mobile';
import { toJS } from 'mobx';
import { observer, useLocalObservable } from 'mobx-react';
import * as config from "../../_config";

import M5APIs from 'm5/M5APIs';
import HomePageStore from 'pages/HomePage/store/HomePageStore';
import LoginByGraphIdPage from 'pages/LoginPage/LoginByGraphIdPage';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import useSnackbarMessage from 'shared/snackbar';
import { useRootStore } from 'store/StoreContextProvider';
import EmployeeDetailPageStore from './store/EmployeeDetailPageStore';

const PluginGroupwareWebPage = () => {
  const { loginStore } = useRootStore();
  const [loading, setLoading] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const teamsStore = useLocalObservable(() => new EmployeeDetailPageStore());
  const pageStore = useLocalObservable(() => new HomePageStore());
  const navigate = useNavigate();
  const location = useLocation();
  const snackbar = useSnackbarMessage();
  const openPath = location.pathname + '/open' + location.search;
  const closePath = location.pathname + '/close' + location.search;
  const [searchParams, setSearchParams] = useSearchParams();

  const NO_DATA_ON_DB = 'No data available.';
  const graphId = `${searchParams.get('graphId')}`;

  const processID = `${searchParams.get('processID')}`;
  const gwid = `${searchParams.get('gwid')}`;
  const messageId = `${searchParams.get('messageId')}`;
  const subject = `${searchParams.get('subject')}`;
  const ur_name = `${searchParams.get('ur_name')}`;
  const ur_email = `${searchParams.get('ur_email')}`;

  const getEmployee = () => {
    if (location.state?.employee) {
      return location.state.employee;
    }
    return loginStore.currentUser;
  }


  const showSetupAlert = () => {
    Dialog.alert({
      content: `For ${ur_name}, please set up a list of peers and subordinates(downwards) in the admin.`,
      confirmText: 'Confirm',
    });
  };

  const onOpenAdvice = async () => {
    let isAccessDone = false;


    if (getEmployee()) {
      if (teamsStore.taskList.length === 0) {
        if (teamsStore.pubDoneList.length === 0) {
          if (teamsStore.prvDoneList.length === 0) {
            // snackbar.error(NO_DATA_ON_DB);
            const doc = {
              type: "TASK",
              subtype: "GROUPWARE",      
              status: "TODO",
              substatus: processID,
              subcode: gwid,
              published: true,
              title: subject,
              subtitle: ur_email,
         
            };
            console.log(doc);
            const res = await M5APIs.createDocs(config.BUCKET_TASK!, [doc], "REPLACE");
            teamsStore.taskList[0] = res.docs[0];
          } else {
            teamsStore.taskList[0] = teamsStore.prvDoneList[0];
          }
        } else {
          isAccessDone = true;
        }
      }

      const employee = getEmployee();

 

      if (isAccessDone) {
        console.log('DONE', openPath);
        navigate(openPath, {
          state: {
            employee: toJS(employee),
            task: toJS(teamsStore.prvDoneList[0]),
            assess: toJS(teamsStore.pubAssessList[0]),
            isAssessDone: true,
          },
        });
      } else {
        console.log('NOTYET', openPath);
        navigate(openPath, {
          state: {
            employee: toJS(employee),
            task: toJS(teamsStore.taskList[0]),
            assess: {userData: {
              "emoticon": "🙂",
              "grade": 1,
              "like": "",
              "message": "",
              "questionList": []
            },},
            isAssessDone: false,
          },
        });
      }
    } else {
      showSetupAlert();
      return;
    }
  };

  const onCloseAssess = async () => {

    if (getEmployee()) {
      let isAccessDone = false;
      if (teamsStore.taskList.length === 0) {
        if (teamsStore.prvDoneList.length === 0) {
          if (teamsStore.pubDoneList.length === 0) {
            const doc = {
              type: "TASK",
              subtype: "GROUPWARE",      
              status: "TODO",
              substatus: processID,
              subcode: gwid,
              published: true,
              title: subject,
              subtitle: ur_email,
         
            };
            console.log(doc);
            const res = await M5APIs.createDocs(config.BUCKET_TASK!, [doc], "REPLACE");
            teamsStore.taskList[0] = res.docs[0];
          } else {
            teamsStore.taskList[0] = teamsStore.pubDoneList[0];
          }
        } else {
          isAccessDone = true;
        }
      }




      const employee = getEmployee();

      if (isAccessDone) {
        navigate(closePath, {
          state: {
            employee: toJS(employee),
            task: toJS(teamsStore.prvDoneList[0]),
            assess: toJS(teamsStore.prvAssessList[0]),
            isAssessDone: true,
          },
        });
      } else {
        navigate(closePath, {
          state: {
            employee: toJS(employee),
            task: toJS(teamsStore.taskList[0]),
            assess: {userData: {
              "emoticon": "🙂",
              "grade": 1,
              "like": "",
              "message": "",
              "questionList": []
            },},
            isAssessDone: false,
          },
        });
      }
    } else {
      showSetupAlert();
      return;
    }
  };

  useEffect(() => {
    console.log('useEffect', loginStore.currentUser);
    if (loginStore.currentUser) {
      fetchTargetsByDeptCode();
    } else {
      const nextUrl = '/groupware/advice/login' + location.search;
      navigate(nextUrl);
    }
  }, [loginStore.currentUser]);

  const fetchTargetsByDeptCode = async () => {
    try {
      //console.log(loginStore.currentUser);
      if (loginStore.currentUser?.userData.downwardsList && loginStore.currentUser?.userData.peerList) {
        pageStore.setTabValue('');
      } else if (loginStore.currentUser?.userData.downwardsList) {
        pageStore.setTabValue('downwards');
      } else if (loginStore.currentUser?.userData.peerList) {
        pageStore.setTabValue('peer');
      }

      pageStore.setTabValue('');
      if (loginStore.currentUser) {
        const res = await pageStore.fetchTargetsByDeptCode(loginStore.currentUser);

        if (pageStore.employeeList.length === 0) {
          Dialog.alert({
            content: 'No peers and downwards available.',
            confirmText: 'Confirm',
          });
          return;
        }

        await fetchTaskItem();

        if (res?.expired) {
          loginStore.onLogout();
          return;
        }
      } else {
        loginStore.onLogout();
        return;
      }
    } catch (err: any) {
      if (err.response.data.header.code === 1) {
        showSetupAlert();
      } else {
        snackbar.error(err.message);
      }
    }
  };

  const fetchTaskItem = async () => {
    try {
      const res = await teamsStore.fetchTaskByGroupwareId(loginStore.currentUser, gwid, processID, subject, ur_email);

      if (res?.expired) {
        loginStore.onLogout();
        return;
      }
    } catch (err: any) {
      snackbar.error(err.message);
    }
  };

  return (
    <>
      {(!loginStore.currentUser || teamsStore.isReady === false) ? (
        <Grid container justifyContent={'center'} style={{ marginTop: '150px' }}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <CircularProgress />

            <div style={{ marginTop: 50 }}>
              Loading PAS for Jeisian...
            </div>
          </Stack>
        </Grid>
      ) : (
        <Box sx={{ width: '100%', overflowY: 'hidden' }} display='flex' justifyContent='center' alignItems='center' minHeight='70vh'>
          <Grid container xs={10} md={10}>
            <Grid xs={12} md={10} mdOffset={2}>
              <Typography style={{ fontWeight: 700, fontSize: '18px', lineHeight: '16px', marginBottom: 3 }}>PAS for Jeisians v1.1.2</Typography>
              <Typography style={{ fontWeight: 500, fontSize: '12px', lineHeight: '16px', color: '#888889', marginTop: 3, marginBottom: '50px' }}>상시 조언을 통한 업무역량 향상</Typography>
            </Grid>
            <Grid xs={12} md={10} mdOffset={2}>
              <Button block type='submit' color='primary' size='large' loading={loading} onClick={onOpenAdvice}>
                <b>Advice</b> in Public
              </Button>
              <Typography style={{ fontWeight: 500, fontSize: '12px', lineHeight: '16px', color: '#888889', marginTop: 3 }}>[공개조언] 진솔한 조언을 보내주세요.</Typography>
            </Grid>
            <Grid xs={12} md={10} mdOffset={2} style={{ marginTop: '70px' }}>
              <Button block type='button' color='primary' size='large' loading={loading} onClick={onCloseAssess}>
                <b>Appraisal</b> in Private
              </Button>
              <Typography style={{ fontWeight: 500, fontSize: '12px', lineHeight: '16px', color: '#888889', marginTop: 3 }}>[비공개평가] 혼자만의 기록을 남기세요.</Typography>
            </Grid>
            {/* <Grid xs={12} md={6} mdOffset={3} style={{ marginTop: "100px" }}>
            <LoadingButton
              type="button"
              color="primary"
              variant="contained"
              size="large"
              loading={loading}
              onClick={onLogout}
              fullWidth={true}
            >
              login again
            </LoadingButton>
          </Grid> */}
          </Grid>
        </Box>
      )}
      {!loginStore.currentUser && <LoginByGraphIdPage loginPath='' />}
    </>
  );
}


export default observer(PluginGroupwareWebPage);